import { Component, input, Input } from '@angular/core';

@Component({
    selector: 'lib-icon',
    templateUrl: './icon.component.html',
    styleUrls: ['./icon.component.scss'],
    standalone: false,
    host: {
      '[style.height]': 'height()',
      '[style.width]': 'width()'
    }
})
export class IconComponent {
  name = input.required<string>();
  height = input<string>();
  width = input<string>();
}
